import React from 'react';
import { useTranslation } from 'react-i18next';
import './footer.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="footer__left">
        <a href="https://panoncologytrials.com/politica-de-privacidad-2/" target="_blank" rel="noopener noreferrer">
          {t('privacyPolicy')}
        </a>
      </div>
      <div className="footer__right">Copyright © 2024 PanOncology Trials. All Rights Reserved.</div>
    </footer>
  );
};

export default Footer;
